/**
 * @file   src\components\HeaderButtons\IntroductionSkeleton.js
 * @brief  This file is responsible for introduction loader
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";

const IntroductionSkeleton = (props) => {
  return (
    <>
      <div className="intro-skeleton-wrapper">
        <div className="flex-shrink-0">
          <div className="intro-skeleton-prof-wrap">prof image</div>
        </div>
        <div className="flex-grow-1 ml-10">
          <div className="intro-skeleton-content">
            <div className="intro-skeleton-content-top">top</div>
            <div className="intro-skeleton-content-btm">btm</div>
          </div>

          <div className="intro-skeleton-outer-propertywrap">
            <div className="intro-skeleton-imgwrap"></div>
            <div className="intro-skeleton-rightsec">
              <div className="intro-skeleton-rightsec-top">top</div>
              <div className="intro-skeleton-rightsec-btm">btm</div>
            </div>
          </div>
        </div>
      </div>

      <div className="intro-skeleton-wrapper">
        <div className="flex-shrink-0">
          <div className="intro-skeleton-prof-wrap">prof image</div>
        </div>
        <div className="flex-grow-1 ml-10">
          <div className="intro-skeleton-content">
            <div className="intro-skeleton-content-top">top</div>
            <div className="intro-skeleton-content-btm">btm</div>
          </div>

          <div className="intro-skeleton-outer-propertywrap">
            <div className="intro-skeleton-imgwrap"></div>
            <div className="intro-skeleton-rightsec">
              <div className="intro-skeleton-rightsec-top">top</div>
              <div className="intro-skeleton-rightsec-btm">btm</div>
            </div>
          </div>
        </div>
      </div>

      <div className="intro-skeleton-wrapper">
        <div className="flex-shrink-0">
          <div className="intro-skeleton-prof-wrap">prof image</div>
        </div>
        <div className="flex-grow-1 ml-10">
          <div className="intro-skeleton-content">
            <div className="intro-skeleton-content-top">top</div>
            <div className="intro-skeleton-content-btm">btm</div>
          </div>

          <div className="intro-skeleton-outer-propertywrap">
            <div className="intro-skeleton-imgwrap"></div>
            <div className="intro-skeleton-rightsec">
              <div className="intro-skeleton-rightsec-top">top</div>
              <div className="intro-skeleton-rightsec-btm">btm</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default IntroductionSkeleton;
